/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:3.2rem;height:3.2rem;padding:.8rem;font-size:1.6rem;line-height:1.6rem;text-align:center;vertical-align:middle;display:block;background-color:inherit;cursor:pointer}"];
export { styles as styles };
